@if (formGroup.get(property.Key)) {
  <mat-form-field [formGroup]="formGroup" class="flex-form-field">
    <mat-label [attr.for]="property.key">{{ property.TextId | translate }}</mat-label>
    <input
      matInput
      type="text"
      [id]="property.Key"
      [formControlName]="property.Key"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput()"
      [matTooltip]="toolTipTextId | translate"
    />
    @if (propertyForm.errors && propertyForm.errors.required) {
      <mat-error [translate]="'UI.Error.Required'"></mat-error>
    }
  </mat-form-field>
}
